export default __webpack_public_path__ + "static/media/Image (1).d50c0848.png";